export interface Leader {
  name: string;
  role: string;
  photoSrc: string;
}

export const boardOfAdvisorsAndDirectors: Leader[] = [
  {
    name: "Sumeet Narang",
    role: "Chairman, Board of Advisors",
    photoSrc: "/images/leadership/sumeet-narang.jpg",
  },
  {
    name: "Sanjay Purohit",
    role: "Member, Board Of Advisors",
    photoSrc: "/images/leadership/sanjay-purohit.jpg",
  },
  {
    name: "Vikram Agarwal",
    role: "Non-Executive, Director",
    photoSrc: "/images/leadership/vikram-agarwal.jpg",
  },
  {
    name: "Gautam Gupta",
    role: "Member, Board Of Advisors",
    photoSrc: "/images/leadership/gautam-gupta.jpg",
  },
  {
    name: "Vinod Nambiar",
    role: "Managing Director, Member, Board Of Advisors",
    photoSrc: "/images/leadership/vinod-nambiar.jpg",
  },
  {
    name: "Abhik Mitra",
    role: "Member, Board Of Advisors",
    photoSrc: "/images/leadership/abhik-mitra.jpg",
  },
];

export const executiveManagement: Leader[] = [
  {
    name: "Vinod Nambiar",
    role: "Managing Director",
    photoSrc: "/images/leadership/vinod-nambiar.jpg",
  },
  {
    name: "Supratim Banerjee",
    role: "President & Chief Financial Officer",
    photoSrc: "/images/leadership/supratim-banerjee.jpg",
  },
  {
    name: "Giridhar Seetharam",
    role: "Chief Executive Officer - Retail",
    photoSrc: "/images/leadership/giridhar-seetharam.jpg",
  },
  {
    name: "Ganesh Subramanian",
    role: "Chief Human Resources Officer",
    photoSrc: "/images/leadership/ganesh-subramanian.jpg",
  },
  {
    name: "Sudhir Shukla",
    role: "Chief Operating Officer - North And East Region",
    photoSrc: "/images/leadership/sudhir-shukla.jpg",
  },
  {
    name: "Rajesh Naidu",
    role: "Chief Operating Officer - South Region",
    photoSrc: "/images/leadership/rajesh-naidu.jpg",
  },
  {
    name: "Ankit Goel",
    role: "Chief Product And Technology Officer",
    photoSrc: "/images/leadership/ankit-goel.jpg",
  },
  {
    name: "Pawan Sharma",
    role: "Head - Supply Chain Operations",
    photoSrc: "/images/leadership/pawan-sharma.jpg",
  },
  {
    name: "Vidhyashankar Jayaraman",
    role: "Chief Merchandising And Marketing Officer",
    photoSrc: "/images/leadership/vidhyashankar-jayaraman.jpg",
  },
  {
    name: "Laxman Ramnarayan",
    role: "Executive Director",
    photoSrc: "/images/leadership/laxman-ramnarayan.jpg",
  },
];
